import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import yinxiang from '@/views/yinxiang/index'
import yinxiangYizhi from '@/views/yinxiang/yinxiang-yizhi'
import spot from '@/views/yinxiang/spot'
import spotView from '@/views/yinxiang/spot-view'
import wanzhuan from '@/views/wanzhuan/index'
import jiaotong from '@/views/wanzhuan/jiaotong'
import wanzhuanNotice from '@/views/wanzhuan/wanzhuan-notice'
import wanzhuanProblem from '@/views/wanzhuan/wanzhuan-problem'
import gonglue from '@/views/wanzhuan/gonglue'
import gonglueView from '@/views/wanzhuan/gonglue-view'
import yanyi from '@/views/wanzhuan/yanyi'
import jinianpin from '@/views/wanzhuan/jinianpin'
import zixun from '@/views/zixun/index'
import zixunView from '@/views/zixun/zixun-view'
import zixunCompany from '@/views/zixun/zixun-company'
import zixunCompanyView from '@/views/zixun/zixun-company-view'
import zixunAnnouncement from '@/views/zixun/zixun-announcement'
import zixunAnnouncementView from '@/views/zixun/zixun-announcement-view'
import yuding from '@/views/yuding/index'
import food from '@/views/yuding/food'
import leisure from '@/views/yuding/leisure'
import hotel from '@/views/yuding/hotel'
import vip from '@/views/yuding/vip'
import club from '@/views/yuding/club'
import lianxi from '@/views/lianxi/index'
import lianxiTeam from '@/views/lianxi/lianxi-team'
import foodView from '@/views/yuding/food-view.vue'
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/',redirect: '/pages/index/index'},
    { path: '/pages/index/index',name: 'index', component: index },
    { path: '/pages/yinxiang/index',name: 'yinxiang',component: yinxiang },
    { path: '/pages/yinxiang/yinxiang-yizhi',name: 'yinxiangYizhi',component: yinxiangYizhi },
    { path: '/pages/yinxiang/spot',name: 'spot',component: spot },
    { path: '/pages/yinxiang/spot-view',name: 'spotView',component: spotView },
    { path: '/pages/wanzhuan/index',name: 'wanzhuan',component: wanzhuan },
    { path: '/pages/wanzhuan/jiaotong',name: 'jiaotong',component: jiaotong },
    { path: '/pages/wanzhuan/wanzhuan-notice',name: 'wanzhuanNotice',component: wanzhuanNotice },
    { path: '/pages/wanzhuan/wanzhuan-problem',name: 'wanzhuanProblem',component: wanzhuanProblem },
    { path: '/pages/wanzhuan/gonglue',name: 'gonglue',component: gonglue },
    { path: '/pages/wanzhuan/gonglue-view',name: 'gonglueView',component: gonglueView },
    { path: '/pages/wanzhuan/yanyi',name: 'yanyi',component: yanyi },
    { path: '/pages/wanzhuan/jinianpin',name: 'jinianpin',component: jinianpin },
    // { path: '/zixun',name: 'zixun',component: zixun },
    // { path: '/zixun-view',name: 'zixunView',component: zixunView },
    { path: '/pages/zixun/zixun-company',name: 'zixunCompany',component: zixunCompany },
    { path: '/pages/zixun/zixun-company-view',name: 'zixunCompanyView',component: zixunCompanyView },
    { path: '/pages/zixun/zixun-announcement',name: 'zixunAnnouncement',component: zixunAnnouncement },
    { path: '/pages/zixun/zixun-announcement-view',name: 'zixunAnnouncementView',component: zixunAnnouncementView },
    { path: '/pages/yuding/index',name: 'yuding',component: yuding },
    { path: '/pages/yuding/food',name: 'food',component: food },
    { path: '/pages/yuding/food-view',name: 'foodView',component: foodView },
    { path: '/pages/yuding/leisure',name: 'leisure',component: leisure },
    { path: '/pages/yuding/hotel',name: 'hotel',component: hotel },
    { path: '/pages/yuding/vip',name: 'vip',component: vip },
    { path: '/pages/yuding/club',name: 'club',component: club },
    { path: '/pages/lianxi/index',name: 'lianxi',component: lianxi },
    { path: '/pages/lianxi/lianxi-team',name: 'lianxiTeam',component: lianxiTeam },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js